/*** ALL ROUTES ARE DEFINDED HERE ***/

const ROUTE_NAMES = {
  BASE_ROUTE: "/",
  PUBLIC_ROUTES: {
    SUPPORT: "/support",
    TERM_AND_CONDITIONS: "/term-and-conditions",
    CONTACT_US: "/contact-us",
    FAQ: "/faq",
    PRIVACY_POLICY: "/privacy-policy"
  },

  MAIN_ROUTES: {
    DASHBOARD: "/dashboard",
    USERS: "/users",
    USER: "/users/:id",
    CMS: "/content-management",
    PROFILE: "/profile",
    SITES: "/sites",
    ADD_SITES: "/sites/add-site",
    SITES_DETAIL: "/sites/:siteId",
    UPDATE_SITE: "/sites/update-site/:siteId",
    CITIES: "/cities",
    CITY_DETAIL: "/cities/:cityId",
    CITY_UPDATE: "/cities/update-city/:cityId",
    REPORT_MANAGEMENT: "/report-management",
    POST_DETAILS: "post-details",
    POST_LISTING: "/report-manager/post-lisiting",
    FEEDBACK: "/feedback",
    FEEDBACK_DETAILS: "/feedback/:feedbackId",
    QUERIES: "/queries",
    QUERY_DETAILS: "/queries/:query",
  },
};

export default ROUTE_NAMES;
